import { FormControl, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ParcelAppEntityParcelWrite,
  PropertyLegalTitleService
} from '../../../../../../openapi';
import { RoadControlsForm } from '../../components/road-controls-set/road-controls.form';
import { environment } from '../../../../../../../environments/environment';
import { PropertyInfoForm } from './property-info.form';

@Injectable()
export class LocationDataForm extends RoadControlsForm {

  public validators = Validators;

  constructor(private pr: PropertyLegalTitleService) {
    super({
      geometry: new FormControl(null, environment.production ? Validators.required : []),

      parcels: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.required, Validators.minLength(1), Validators.maxLength(255)]
        }
      ),
      parcels2: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.required, Validators.minLength(1), Validators.maxLength(255)]
        }
      )
    });
  }

  public createPropertyInfoForm(): void {
    this.addControl('propertyInfo', new PropertyInfoForm(this.pr));
  }

  public get propertyInfoForm(): PropertyInfoForm | undefined {
    return this.get('propertyInfo') as PropertyInfoForm | undefined;
  }

  public get geometry(): FormControl {
    return this.get('geometry') as FormControl;
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcels2(): FormControl {
    return this.get('parcels2') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return [...this.parcels2.value, ...this.parcels.value];
  }

  public override patchFormValues(app: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues({
      geometry: app?.geometry,
      roadName: app?.roadName || '',
      roadNumber: app?.roadNumber || '',
      street: app.street
    });

    if (app?.parcels?.length) {
      this.parcels.setValue(app.parcels.filter(v => v.tag === 'parcels'));
      this.parcels2.setValue(app.parcels.filter(v => v.tag === 'parcels2'));
    }
    this.propertyInfoForm?.patchFormValues(app);
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      geometry: this.geometry.value,

      roadName: this.roadName.value,
      roadNumber: this.roadNumber.value,
      street: this.street.value,

      ...this.propertyInfoForm?.toWriteModel()
    };
  }
}
